export default "__VITE_ASSET__1d5a7b44__"